import React, { useState } from 'react';

function RegisterPage() {
  const [userPrincipalName, setUserPrincipalName] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [ssoId, setSsoId] = useState('');
  const [mobileNubmer, setMobileNubmer] = useState('');
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const [surname, setSurname] = useState('');
  const [givenName, setGivenName] = useState('');

  const [ccId, setCcId] = useState('');
  const [ebId, setEbId] = useState('');
  const [vtId, setVtId] = useState('');
  const [ptId, setPtId] = useState('');
  
  const [lpId, setLpId] = useState('');
  const [leId, setLeId] = useState('');
  const [ccRegdate, setCcRegdate] = useState('');
  const [ebRegdate, setEbRegdate] = useState('');
  const [vtRegdate, setVtRegdate] = useState('');
  const [ptRegdate, setPtRegdate] = useState('');


  const generateRandomBufferForUsername = (length) => {
    const characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz012345678';
  
    let password = '';
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      password += characters.charAt(randomIndex);
    }

    return password;
  }



  const generateRandomPassword = (length) => {
    const characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+~`|}{[]:;?><,./-=';
  
    let password = '';
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      password += characters.charAt(randomIndex);
    }
  

    return password;
  }
  
  const generateRandomUsername = () => {
    const adjectives = ['happy', 'clever', 'brave', 'sunny', 'vibrant', 'playful'];
    const nouns = ['Michelangelo', 'Leonardo', 'AprilONeil', 'Karai', 'Splinter', 'CaseyJones'];
    

    const randomAdjectiveIndex = Math.floor(Math.random() * adjectives.length);
    const randomNounIndex = Math.floor(Math.random() * nouns.length);
  
    const adjective = adjectives[randomAdjectiveIndex];
    const noun = nouns[randomNounIndex];
  
    const username = adjective + '' + noun + generateRandomBufferForUsername(5);
  
    return username;
  }
  
  const generateRandomHKMobileNumber = () => {
    const prefix = '6';
    const length = 8;
    
    let number = prefix;
    for (let i = 0; i < length; i++) {
      number += Math.floor(Math.random() * 10);
    }
    
    return number;
  }
  


  const handleGenerateMobileNumber = (e) => {
    const randomHKMobileNumber = generateRandomHKMobileNumber();
    console.log(randomHKMobileNumber);
    setMobileNubmer(randomHKMobileNumber)
}


  const handleGeneratePassword = (e) => {
    // Example usage: generate a random password with a length of 12
    const randomPassword = generateRandomPassword(12);
    setPassword(randomPassword)
}


  const handleGenerateUsername = (e) => {
    // Example usage: generate a random password with a length of 12
    const randomUsername = generateRandomUsername();
    setUserPrincipalName(randomUsername);
    setDisplayName(randomUsername);
    setSsoId(randomUsername);


    setEmail(randomUsername + "@gmail.com");
    setSurname(randomUsername +" Lau");
    setGivenName(randomUsername+ " Michael");
    
}


  const handleSubmit = (e) => {
    e.preventDefault();

    // Prepare the form data
    // const formData = new URLSearchParams();
    // formData.append('userPrincipalName', userPrincipalName);
    // formData.append('displayName', displayName);
    // formData.append('password', password);
    // formData.append('ssoId', ssoId);
    // formData.append('mobilePhone', mobileNubmer);
    // formData.append('email', email);
    // formData.append('surname', surname);
    // formData.append('givenName', givenName);

    const formData = {
      'userPrincipalName':userPrincipalName,
      'displayName':displayName,
      'password':password,
      'ssoId':ssoId,
      mobilePhone: mobileNubmer,
      email,
      surname,
      givenName,
      'ccId':ccId,
      'ebId':ebId,
      'vtId':vtId,
      'lpId':lpId,
      'leId':leId,
      'CCRegdate':ccRegdate,
      'EBRegdate':ebRegdate,
      'VTRegdate':vtRegdate,
      'PTRegdate':ptRegdate
    };

  

    // Send the request to the API
    fetch('https://callbackserver.tdaburger.com/create-user', {
      method: 'POST',
      headers: {
        // 'Content-Type': 'application/x-www-form-urlencoded'
        'Content-Type': 'application/json' // Update the Content-Type header

      },
      //body: formData.toString()
      body: JSON.stringify(formData) // Convert the form data object to a JSON string
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        if(data.data.result==='success'){
          alert('User Created Successfully');
        }else{
          alert(`User Creation Failed: ${data.data.result}`);
        }

    
      })
      .catch(error => {
        // Handle any errors
        console.error(error);
      });
  };

  return (
    <div style={{ padding: 20 }}>
      <h1>This is a CONNECT Register Form</h1>
      <form onSubmit={handleSubmit}>




        
        <div>
          <label htmlFor="userPrincipalName">User Principal Name:</label>
          <input
            type="text"
            id="userPrincipalName"
            value={userPrincipalName}
            onChange={(e) => setUserPrincipalName(e.target.value)}
          />
          <span> {userPrincipalName}</span>
        </div>
        <div>
          <label htmlFor="displayName">Display Name:</label>
          <input
            type="text"
            id="displayName"
            value={displayName}
            onChange={(e) => setDisplayName(e.target.value)}
          />
            <span> {displayName}</span>
        </div>
        <div>
          <label htmlFor="ssoId">ssoId:</label>
          <input
            type="text"
            id="ssoId"
            value={ssoId}
            onChange={(e) => setSsoId(e.target.value)}
          />
            <span> {ssoId}</span>
        </div>
        <div>
          <label htmlFor="mobileNubmer">mobileNubmer:</label>
          <input
            type="text"
            id="mobileNubmer"
            value={mobileNubmer}
            onChange={(e) => setMobileNubmer(e.target.value)}
          />
            <span> {mobileNubmer}</span>
        </div>

        <div>
          <label htmlFor="email">email:</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
            <span> {email}</span>
        </div>

        <div>
          <label htmlFor="surname">surname:</label>
          <input
            type="text"
            id="surname"
            value={surname}
            onChange={(e) => setSurname(e.target.value)}
          />
            <span> {surname}</span>
        </div>

        <div>
          <label htmlFor="givenName">givenName:</label>
          <input
            type="text"
            id="givenName"
            value={givenName}
            onChange={(e) => setGivenName(e.target.value)}
          />
            <span> {givenName}</span>
        </div>
        <div>
          <label htmlFor="password">Password:</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <span> {password}</span>
        </div>


        <div>
          <label htmlFor="ccId">CC ID:</label>
          <input
            type="text"
            id="ccId"
            value={ccId}
            onChange={(e) => setCcId(e.target.value)}
          />
            <span>Sample Value: 268869982</span>
        </div>


        <div>
          <label htmlFor="ccId">EB ID:</label>
          <input
            type="text"
            id="ebId"
            value={ebId}
            onChange={(e) => setEbId(e.target.value)}
          />
            <span>Sample Value: AIAC_1691212102212</span>
        </div>


        <div>
          <label htmlFor="vtId">VT ID:</label>
          <input
            type="text"
            id="vtId"
            value={vtId}
            onChange={(e) => setVtId(e.target.value)}
          />
            <span>Sample Value: V800042404</span>
        </div>


        <div>
          <label htmlFor="ptId">PT ID:</label>
          <input
            type="text"
            id="ptId"
            value={ptId}
            onChange={(e) => setPtId(e.target.value)}
          />
            <span>Sample Value: 011835608</span>
        </div>

        <div>
          <label htmlFor="leId">LE ID:</label>
          <input
            type="text"
            id="leId"
            value={leId}
            onChange={(e) => setLeId(e.target.value)}
          />
            <span>Sample Value: test293</span>
        </div>


        <div>
          <label htmlFor="ccRegdate">CC Register Date (CCRegdate):</label>
          <input
            type="text"
            id="ccRegdate"
            value={ccRegdate}
            onChange={(e) => setCcRegdate(e.target.value)}
          />
            <span>Sample Value: Jul 12, 2019, 1:14:06 PM</span>
        </div>

        <div>
          <label htmlFor="ebRegdate">EB Register Date (EBRegdate):</label>
          <input
            type="text"
            id="ebRegdate"
            value={ebRegdate}
            onChange={(e) => setEbRegdate(e.target.value)}
          />
            <span>Sample Value: Jul 12, 2019, 1:14:06 PM</span>
        </div>


        <div>
          <label htmlFor="vtRegdate">VT Register Date (VTRegdate):</label>
          <input
            type="text"
            id="vtRegdate"
            value={vtRegdate}
            onChange={(e) => setVtRegdate(e.target.value)}
          />
            <span>Sample Value: Jul 12, 2019, 1:14:06 PM</span>
        </div>



        <div>
          <label htmlFor="ptRegdate">PT Register Date (PTRegdate):</label>
          <input
            type="text"
            id="ptRegdate"
            value={ptRegdate}
            onChange={(e) => setPtRegdate(e.target.value)}
          />
            <span>Sample Value: Jul 12, 2019, 1:14:06 PM</span>
        </div>




        



        <button type="submit">Submit</button> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <button type="button" onClick={handleGeneratePassword}>Generate Password</button>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <button type="button" onClick={handleGenerateUsername}>Generate Username</button>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <button type="button" onClick={handleGenerateMobileNumber}>Generate Mobile Number</button>
      </form>
    </div>
  );
}

export default RegisterPage;